import { resetPanel, resetSection } from 'weblite-router'
import { RoomAppBarInfo } from '$common/room-app-bar/room-app-bar-info'
import { getPrivateSpace } from '$logic/private-space'
import { openSharedMedia } from '$logic/router'
import { t } from '$i18n'

export function PrivateSpaceAppBar() {
  return (
    <RoomAppBarInfo
      onClick={async () => {
        resetSection('right')
        resetPanel('roomProfile')

        openSharedMedia(getPrivateSpace().roomId)
      }}
      avatarSrc="assets/svg/private-space.svg"
      primaryText={t('myAccount.savedMessage')}
      callElement={null}
    />
  )
}
